import { NgModule } from '@angular/core';
import { CompatThreatmetrixComponent } from './compat-threatmetrix.component';

@NgModule({
  declarations: [CompatThreatmetrixComponent],
  entryComponents: [CompatThreatmetrixComponent],
})
export class CompatThreatmetrixModule {}
